import type { ReactNode } from "react";

interface FiltroDeListadoProps {
  /** Rótulo visible, que además es el `<label>` del control. */
  etiqueta: string;
  /** `id` del control que envuelve: es lo que ata el `<label>` a él. */
  id: string;
  children: ReactNode;
}

/**
 * Un filtro de una barra de filtros: rótulo + control, de ancho fijo.
 *
 * Vive suelto y no dentro de cada pantalla porque ya lo necesitan tres
 * listados (Informes en proceso, Revisiones pendientes y el tablero de
 * Feedback) y la barra tiene que verse igual en todos. El ancho fijo es parte
 * del componente a propósito: sin él, cada select toma el ancho de su opción
 * más larga y la barra queda con las columnas bailando entre pantallas.
 *
 * El `<label>` va atado por `htmlFor` y no como texto suelto al lado: es lo
 * que hace que un lector de pantalla anuncie "Módulo" al llegar al select, y
 * lo que deja que un test lo busque por su rótulo.
 */
export function FiltroDeListado({ etiqueta, id, children }: FiltroDeListadoProps) {
  return (
    <div className="flex items-center gap-2">
      <label htmlFor={id} className="text-ink-muted text-xs font-bold whitespace-nowrap">
        {etiqueta}
      </label>
      <div className="w-[11.875rem]">{children}</div>
    </div>
  );
}
